import { useEffect, useState } from 'react';
import { IProductHolder, getProductHolders } from '../../Services/productEntitlements';

/** Les comptes concernés par un produit : droit posé et consommation mesurée. */
export const useProductHolders = (product: string) => {
	const [holders, setHolders] = useState<IProductHolder[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		setError(null);
		getProductHolders(product)
			.then((list) => {
				if (!cancelled) setHolders(list || []);
			})
			.catch((e: any) => {
				if (cancelled) return;
				setHolders([]);
				// ⚠️ Une erreur ne se rend PAS comme une liste vide : « aucun compte
				// ne possède ce produit » est une conclusion, et elle serait fausse.
				setError(e?.message || 'Chargement impossible');
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [product]);

	return { holders, loading, error };
};
